import { IAuthUserPerfil, AuthUserPerfilId } from './IAuthUserPerfil';

export default ((): IAuthUserPerfil => {
  return {
    id: AuthUserPerfilId.AssessorAdmin,
    nome: "Administrador",

    associadoRoute: {
      assembleias: {
        pre: {
          ver: false,
          videos: {
            ver: false,
            participar: false
          },
          documentos: {
            ver: false,
            participar: false,
          },
          duvidasSugestoes: {
            ver: false,
            participar: false
          }
        },
        live: {
          ver: false,
          video: {
            ver: false,
            participar: false
          },
          documentos: {
            ver: false,
            participar: false,
          },
          duvidasSugestoes: {
            ver: false,
            participar: false
          }
        },
        pautas: {
          ver: false,
          participar: false
        },
      },
    },
  
    assessorRoute: {
      convocados: {
        view: true,
      },
      assembleias: {
        ver: true,
        alterarSituacao: true,
        bloquearConvocacao: true,
        convocar: true,
        documentos: {
          ver: true,
          editar: true,
        },
        participantes: {
          verTotal: true,
          confirmar: true
        },
        pautas: {
          ver: true,
          alterarSituacao: true,
          incluirVotoManual: true,
          editar: true,
          deletar: true
        },
        cadastroPauta: {
          cadastrar: true
        },
        videos: {
          editar: true,
        },
      },
  
      duvidasSugestoes: {
        ver: true,
        responder: true,
        alterarSituacao: true,
        incluirPergunta: true,
      }
    }
    
  }
})();